"use client";

import Link from "next/link";

interface BreadcrumbItem {
  name: string;
  href: string;
}

interface BreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  showBack?: boolean;
  backText?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  breadcrumbs,
  showBack = true,
}) => {
  return (
    <div className="bg-PrimaryLightBlue bg-center bg-cover h-mob-50 sm:h-tab-70 lg:h-[6vw]  text-white mb-mob- sm:mb-tab-25 lg:mb-web-40">
      <div className="flex justify-between items-center h-full max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto">
        {/* Breadcrumb Navigation */}
        <nav className="flex items-center gap-mob-15 sm:gap-tab-15 lg:gap-web-15">
          {breadcrumbs.map((crumb, index) => (
            <span key={index} className="flex items-center text-mob-15 sm:text-tab-15 lg:text-web-20 leading-[100%]">
              <Link href={crumb.href} className="hover:underline">
                {crumb.name}
              </Link>
              {index < breadcrumbs.length - 1 && (
                <span className="text-mob-20 sm:text-tab-20 lg:text-web-25 block ml-mob-8 sm:ml-tab-8 lg:ml-web-10 leading-[100%]">›</span>
              )}
            </span>
          ))}
        </nav>

        {/* Return to Previous Page */}
        {showBack && (
          <button
            onClick={() => window.history.back()}
            className=" hover:underline hidden lg:flex items-center lg:text-web-20 leading-[100%] lg:gap-web-8"
          >
            <span className="block text-web-25 mt-[-.2vw]">‹</span>
             Return to previous page
          </button>
        )}
      </div>
    </div>
  );
};

export default Breadcrumb;
